module.exports = __webpack_public_path__ + "static/img/en-2.d27d9cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en-2.png
// module id = iBlT
// module chunks = 1